<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="4">
					<search-input
						:label="getMessage_('QWCC001302')"
						paramKey="custNm"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="searchParams.custNm"
						:readonly="true"
						:placeholder="getMessage_('QWCC001656')"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPqyCpnyPopup"></i></template>
					</search-input>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
		<!-- 팝업추가 영역 -->
		<comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId"></comp-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	components: { SearchInput, CompPopup },
	async created() {
		try {
			this.$sf_toggleLoading(true);
			await this.getList_();
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		} finally {
			this.$sf_toggleLoading(false);
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			if (param.key === 'custNm') {
				this.setSearchParam_({ key: 'custCd', value: '' });
			}
			this.setSearchParam_(param);
		},
		//협력사조회 팝업
		onPqyCpnyPopup() {
			let params = {
				cpnyScn: '20',
				cpnyCd: this.searchParams.custCd
			};
			this.$refs.compPopup.open(params);
		},
		qpyCpnyData({ cpnyCd, cpnyNm }) {
			this.setSearchParam_({ key: 'custCd', value: cpnyCd });
			this.setSearchParam_({ key: 'custNm', value: cpnyNm });
		},
		async searchList() {
			try {
				if (!this.searchParams.custCd && !this.searchParams.custNm) {
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001302')]));
				}
				this.$sf_toggleLoading(true);
				await this.getList_();
				await this.getDetailList_();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
